export default __webpack_public_path__ + "static/arrow-287163235ee98e4a92ad569389d782a2.png";